import React, { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import api from '../services/api';

const fmtFechaHora = (d) => {
  if (!d) return '';
  const dt = new Date(d);
  const fecha = dt.toLocaleDateString('es-PE', { day: '2-digit', month: '2-digit', year: 'numeric' });
  const hora  = dt.toLocaleTimeString('es-PE', { hour: '2-digit', minute: '2-digit', hour12: true });
  return `${fecha}  ${hora}`;
};

const API = process.env.REACT_APP_API_URL || 'http://localhost:5001';
const logoUrl = (empresa) => empresa?.logo ? `${API}${empresa.logo}` : null;

/* ══════════════════════════════════════════════════════
   FORMATO A4
══════════════════════════════════════════════════════ */
function DespachoA4({ venta, empresa, lineas, totalItems }) {
  return (
    <div className="recibo a4">
      <div className="a4-header">
        <div className="a4-hdr-left">
          {logoUrl(empresa) && (
            <img src={logoUrl(empresa)} alt="logo" className="a4-logo" />
          )}
          <div className="a4-empresa-nombre">{empresa?.razon_social || 'EMPRESA'}</div>
          <div className="a4-empresa-ruc">RUC: {empresa?.ruc || ''}</div>
          {empresa?.direccion && <div className="a4-empresa-dir">{empresa.direccion}</div>}
          {empresa?.telefono  && <div className="a4-empresa-tel">Tel: {empresa.telefono}</div>}
        </div>
        <div className="a4-hdr-right">
          <div className="a4-doc-box">
            <div className="a4-doc-tipo">ORDEN DE DESPACHO</div>
            <div className="a4-doc-num">{venta.numero}</div>
          </div>
        </div>
      </div>

      <div className="a4-info-block">
        <div className="a4-info-row">
          <span className="a4-info-key">FECHA</span>
          <span className="a4-info-val">{fmtFechaHora(venta.creado_en)}</span>
        </div>
        <div className="a4-info-row">
          <span className="a4-info-key">CLIENTE</span>
          <span className="a4-info-val bold">{venta.cliente_nombre || 'CLIENTES VARIOS'}</span>
        </div>
        <div className="a4-info-row">
          <span className="a4-info-key">ATENDIDO POR</span>
          <span className="a4-info-val">{venta.vendedor_nombre || venta.caja_nombre || '—'}</span>
        </div>
        {venta.observacion && (
          <div className="a4-info-row">
            <span className="a4-info-key">OBSERVACIÓN</span>
            <span className="a4-info-val">{venta.observacion}</span>
          </div>
        )}
      </div>

      <table className="a4-tabla">
        <thead>
          <tr>
            <th className="a4-th" style={{ width: 130 }}>Almacén</th>
            <th className="a4-th ctr" style={{ width: 46 }}>Cant</th>
            <th className="a4-th ctr" style={{ width: 40 }}>Und</th>
            <th className="a4-th">Descripción</th>
            <th className="a4-th ctr" style={{ width: 60 }}>Check</th>
          </tr>
        </thead>
        <tbody>
          {lineas.map((l, i) => (
            <tr key={l.id || i} className={i % 2 === 0 ? 'a4-tr-par' : ''}>
              <td className="a4-td bold">{l.almacen_nombre || '—'}</td>
              <td className="a4-td ctr">{parseFloat(l.cantidad)}</td>
              <td className="a4-td ctr">{l.unidad_short || 'UND'}</td>
              <td className="a4-td">
                <span className="a4-prod-name">{l.producto_nombre}</span>
                {l.codigo && <span className="a4-prod-cod"> [{l.codigo}]</span>}
              </td>
              <td className="a4-td ctr"><span className="dsp-check" /></td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="dsp-total-items">
        TOTAL ÍTEMS: <strong>{lineas.length}</strong> &nbsp;·&nbsp; TOTAL UNIDADES: <strong>{totalItems}</strong>
      </div>

      <div className="dsp-firmas">
        <div className="a4-firma-block">
          <div className="a4-firma-line">_______________________________</div>
          <div className="a4-firma-label">ENTREGADO POR</div>
        </div>
        <div className="a4-firma-block">
          <div className="a4-firma-line">_______________________________</div>
          <div className="a4-firma-label">RECIBIDO POR</div>
        </div>
      </div>
    </div>
  );
}

/* ══════════════════════════════════════════════════════
   FORMATO 80mm
══════════════════════════════════════════════════════ */
function DespachoTicket({ venta, empresa, lineas, totalItems }) {
  return (
    <div className="recibo ticket t80">
      <div className="tk-hdr">
        {logoUrl(empresa) && (
          <img src={logoUrl(empresa)} alt="logo" className="tk-logo" />
        )}
        <div className="tk-empresa">{empresa?.razon_social || 'MI EMPRESA'}</div>
        {empresa?.ruc && <div className="tk-ruc">RUC: {empresa.ruc}</div>}
      </div>

      <div className="tk-sep-solid" />

      <div className="tk-doc-tipo">ORDEN DE DESPACHO</div>
      <div className="tk-doc-num">{venta.numero}</div>

      <div className="tk-sep-dot" />

      <div className="tk-info">
        <div className="tk-info-row">
          <span className="tk-key">FECHA</span>
          <span className="tk-val">{fmtFechaHora(venta.creado_en)}</span>
        </div>
        <div className="tk-info-row">
          <span className="tk-key">CLIENTE</span>
          <span className="tk-val">{venta.cliente_nombre || 'CLIENTES VARIOS'}</span>
        </div>
        <div className="tk-info-row">
          <span className="tk-key">ATENDIDO</span>
          <span className="tk-val">{venta.vendedor_nombre || venta.caja_nombre || '—'}</span>
        </div>
      </div>

      <div className="tk-sep-dot" />

      <table className="tk-tabla">
        <thead>
          <tr>
            <th className="tk-th">Almacén</th>
            <th className="tk-th ctr">Cant</th>
            <th className="tk-th ctr">Und</th>
            <th className="tk-th">Descripción</th>
          </tr>
        </thead>
        <tbody>
          {lineas.map((l, i) => (
            <tr key={l.id || i}>
              <td className="tk-td bold">{l.almacen_nombre || '—'}</td>
              <td className="tk-td ctr">{parseFloat(l.cantidad)}</td>
              <td className="tk-td ctr">{l.unidad_short || 'UND'}</td>
              <td className="tk-td">{l.producto_nombre}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="tk-sep-dot" />
      <div className="tk-tot-row total">
        <span>ÍTEMS: {lineas.length}</span>
        <span>UNIDADES: {totalItems}</span>
      </div>

      {venta.observacion && (
        <div className="tk-obs">Obs: {venta.observacion}</div>
      )}

      <div className="tk-sep-dot" />
      <div className="dsp-tk-firma">
        <div>ENTREGADO: ______________</div>
        <div>RECIBIDO:&nbsp;&nbsp; ______________</div>
      </div>
    </div>
  );
}

/* ══════════════════════════════════════════════════════
   ESTILOS
══════════════════════════════════════════════════════ */
const CSS_GLOBAL = (fmt) => `
  * { box-sizing: border-box; margin: 0; padding: 0; }
  @page {
    size: ${fmt === 'a4' ? 'A4' : '80mm auto'};
    margin: 0;
  }

  body.fmt-a4 {
    font-family: Arial, Helvetica, sans-serif;
    font-size: 9.5pt;
    color: #111;
    background: #fff;
  }

  .a4 .a4-header { display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 10px; gap: 16px; }
  .a4 .a4-hdr-left { flex: 1; }
  .a4 .a4-logo { max-width: 130px; max-height: 80px; margin-bottom: 6px; display: block; }
  .a4 .a4-empresa-nombre { font-size: 13pt; font-weight: bold; text-transform: uppercase; line-height: 1.2; }
  .a4 .a4-empresa-ruc { font-size: 10pt; font-weight: bold; margin-top: 2px; }
  .a4 .a4-empresa-dir, .a4 .a4-empresa-tel { font-size: 8pt; color: #444; margin-top: 2px; }
  .a4 .a4-hdr-right { flex-shrink: 0; width: 200px; }
  .a4 .a4-doc-box { border: 2px solid #222; text-align: center; padding: 8px 12px; }
  .a4 .a4-doc-tipo { font-size: 11pt; font-weight: bold; text-transform: uppercase; letter-spacing: 0.5px; }
  .a4 .a4-doc-num { font-size: 11pt; font-weight: bold; letter-spacing: 1px; color: #333; border-top: 1px solid #aaa; padding-top: 4px; margin-top: 6px; }

  .a4 .a4-info-block { border-top: 1.5px solid #222; border-bottom: 1.5px solid #222; padding: 6px 0; margin-bottom: 10px; }
  .a4 .a4-info-row { display: flex; gap: 12px; border-bottom: 1px dotted #bbb; padding: 3px 2px; align-items: baseline; }
  .a4 .a4-info-key { font-weight: bold; font-size: 8.5pt; min-width: 110px; flex-shrink: 0; }
  .a4 .a4-info-val { font-size: 9pt; color: #222; }
  .a4 .a4-info-val.bold { font-weight: bold; }

  .a4 .a4-tabla { width: 100%; border-collapse: collapse; margin-bottom: 10px; font-size: 9pt; }
  .a4 .a4-th { background: #222; color: #fff; padding: 5px 6px; text-align: left; font-size: 8.5pt; font-weight: bold; }
  .a4 .a4-td { padding: 5px 6px; border-bottom: 1px dotted #ccc; vertical-align: top; font-size: 9pt; }
  .a4 .a4-tr-par td { background: #f9f9f9; }
  .a4 .a4-prod-cod { font-size: 7.5pt; color: #666; }

  .a4 .dsp-check { display: inline-block; width: 11px; height: 11px; border: 1.5px solid #333; }
  .a4 .dsp-total-items { text-align: right; font-size: 10pt; border-top: 2px solid #222; padding: 6px 4px; margin-bottom: 20px; }
  .a4 .dsp-firmas { display: flex; justify-content: space-around; margin-top: 40px; }
  .a4 .a4-firma-block { text-align: center; font-size: 8pt; color: #555; }
  .a4 .a4-firma-label { margin-top: 4px; font-weight: bold; }

  body.fmt-80 {
    font-family: 'Courier New', Courier, monospace;
    font-size: 9pt;
    color: #000;
    background: #fff;
    width: 76mm;
    max-width: 76mm;
  }
  .ticket { padding: 2mm; }
  .tk-hdr { text-align: center; margin-bottom: 4px; }
  .tk-logo { max-width: 60px; max-height: 50px; margin-bottom: 3px; }
  .t80 .tk-empresa { font-size: 12pt; font-weight: bold; text-transform: uppercase; }
  .t80 .tk-ruc { font-size: 10.5pt; font-weight: bold; margin-top: 2px; }
  .tk-sep-solid { border: none; border-top: 2px solid #000; margin: 4px 0; }
  .tk-sep-dot   { border: none; border-top: 1px dashed #555; margin: 3px 0; }
  .t80 .tk-doc-tipo { text-align: center; font-size: 10.5pt; font-weight: bold; text-transform: uppercase; }
  .t80 .tk-doc-num  { text-align: center; font-size: 9pt; margin-bottom: 2px; letter-spacing: 0.5px; }
  .tk-info { margin: 3px 0; }
  .tk-info-row { display: flex; gap: 4px; margin-bottom: 1px; }
  .t80 .tk-key { font-size: 7.5pt; font-weight: bold; min-width: 68px; flex-shrink: 0; }
  .t80 .tk-val { font-size: 7.5pt; }
  .tk-tabla { width: 100%; border-collapse: collapse; margin: 2px 0; }
  .t80 .tk-th { font-size: 7pt; font-weight: bold; padding: 2px 2px; border-bottom: 1px solid #000; text-align: left; }
  .t80 .tk-td { font-size: 7.5pt; padding: 2px 2px; border-bottom: 1px dotted #aaa; vertical-align: top; }
  .tk-tot-row { display: flex; justify-content: space-between; margin-bottom: 1px; }
  .t80 .tk-tot-row.total { font-size: 9pt; font-weight: bold; }
  .t80 .tk-obs { font-size: 7pt; font-style: italic; margin: 3px 0; }
  .t80 .dsp-tk-firma { font-size: 8pt; margin-top: 14px; display: flex; flex-direction: column; gap: 14px; }

  .ctr  { text-align: center; }
  .bold { font-weight: bold; }

  @media screen {
    body { background: #d0d0d0 !important; }
    .recibo { background: #fff; margin: 20px auto; padding: 20px; box-shadow: 0 2px 12px rgba(0,0,0,.3); }
    body.fmt-a4 .recibo { max-width: 210mm; }
    body.fmt-80 .recibo { max-width: 80mm; }
  }
  @media print {
    body { background: #fff !important; }
    .recibo { box-shadow: none !important; margin: 0 !important; }
    body.fmt-a4 .recibo { padding: 12mm 15mm !important; }
    body.fmt-80 .recibo { padding: 3mm 2mm !important; }
  }
`;

/* ══════════════════════════════════════════════════════
   Página principal
══════════════════════════════════════════════════════ */
export default function VentaDespachoPage() {
  const { id }   = useParams();
  const [params] = useSearchParams();
  const fmt      = params.get('fmt') === '80' ? '80' : 'a4';

  const [venta,   setVenta]   = useState(null);
  const [empresa, setEmpresa] = useState(null);
  const [error,   setError]   = useState('');
  const [listo,   setListo]   = useState(false);

  useEffect(() => {
    document.body.className = `fmt-${fmt}`;
    return () => { document.body.className = ''; };
  }, [fmt]);

  useEffect(() => {
    Promise.all([
      api.get(`/api/ventas/${id}`),
      api.get('/api/empresa'),
    ])
      .then(([rv, re]) => {
        const v = rv.data?.data || rv.data;
        if (v?.numero) document.title = `DESPACHO ${v.numero}`;
        setVenta(v);
        setEmpresa(re.data?.empresa || re.data?.data || re.data);
        setListo(true);
      })
      .catch(() => setError('No se pudo cargar la orden de despacho.'));
  }, [id]);

  useEffect(() => {
    if (!listo) return;
    const t = setTimeout(() => window.print(), 700);
    return () => clearTimeout(t);
  }, [listo]);

  const css = CSS_GLOBAL(fmt);

  if (error)  return <><style>{css}</style><div style={{ padding: 20, color: 'red' }}>{error}</div></>;
  if (!listo) return <><style>{css}</style><div style={{ padding: 20 }}>Cargando orden de despacho...</div></>;

  // Agrupar por almacén para facilitar el picking
  const lineas = [...(venta.lineas || [])].sort((a, b) =>
    String(a.almacen_nombre || '').localeCompare(String(b.almacen_nombre || '')));
  const totalItems = lineas.reduce((s, l) => s + parseFloat(l.cantidad || 0), 0);

  return (
    <>
      <style>{css}</style>
      {fmt === 'a4'
        ? <DespachoA4     venta={venta} empresa={empresa} lineas={lineas} totalItems={totalItems} />
        : <DespachoTicket venta={venta} empresa={empresa} lineas={lineas} totalItems={totalItems} />
      }
    </>
  );
}
